import { GET_QUESTION_ANSWER, GET_TESTIMONIALS_DETAILS } from "./actions";

const initialState = {
  questionAnswerList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  //   testimonialData: {},
  loading: true,
};

const questionAnswerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_QUESTION_ANSWER:
      return {
        ...state,
        loading: false,
        questionAnswerList: payload,
      };
    // case GET_TESTIMONIALS_DETAILS:
    //   return {
    //     ...state,
    //     loading: false,
    //     testimonialData: payload,
    //   };

    default:
      return state;
  }
};

export default questionAnswerReducer;
